import { BaseModelService } from "./base-model.service"
import { Injectable } from "@angular/core"
import { Tariff } from "./tariff.model"
import { TariffSerializer } from "serializers/tariff.serializer"
import { Observable } from "rxjs"

@Injectable()
export class TariffService extends BaseModelService<Tariff> {
  constructor() {
    super()

    this.configure({
      basePath:  'tariffs',
      key:       'tariff',
      pluralKey: 'tariffs',
      serializer: TariffSerializer
    }) 
  }

  /**
   * Делает запрос в Яндекс и актуализирует список тарифов
   * @returns список тарифов
   */
  refresh(): Observable<Tariff[]> {
    let url = this.buildUrl('refresh')
    return this.post(url).map(data => data['tariffs'] as Tariff[])
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/tariff.service.ts